export const responseBlobAccountMapping = '';